// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../../shared/Ui.re.mjs";
import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as HomeContent from "./HomeContent.re.mjs";
import * as Core from "@linaria/core";
import * as HomeMolecules from "../../molecules/home/HomeMolecules.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

function FeaturedArtistsSection(props) {
  let artists = props.artists;
  if (artists.length === 0) {
    return null;
  } else {
    return JsxRuntime.jsx("section", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
                    children: t`Featured Artists`,
                    className: Core.cx("mb-2")
                  }),
                  JsxRuntime.jsx(HomeAtoms.SerifHeading.make, {
                    level: 3,
                    children: t`Browse featured artists`,
                    className: Core.cx("text-3xl md:text-4xl")
                  })
                ]
              }),
              JsxRuntime.jsx("p", {
                children: t`Independent artists, ready to deliver anywhere in the world.`,
                className: Core.cx("hidden md:block text-xs tracking-wide text-gray-500 font-light italic whitespace-nowrap")
              })
            ],
            className: Core.cx("flex items-end justify-between mb-10 md:mb-12 border-b border-gray-200 pb-4 gap-6")
          }),
          JsxRuntime.jsx("div", {
            children: artists.map((artist, idx) => {
              let name = artist.name;
              let src = artist.sampleImage;
              let country = artist.country;
              return JsxRuntime.jsxs("figure", {
                children: [
                  JsxRuntime.jsx("a", {
                    children: JsxRuntime.jsx("div", {
                      children: src !== undefined ? JsxRuntime.jsx(Ui.DImg.make, {
                          src: src,
                          alt: t`Sample artwork by ${name}`,
                          className: Core.cx("w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"),
                          imgixParams: HomeMolecules.portraitParams(),
                          sizes: "(min-width: 768px) 25vw, 50vw",
                          width: 480,
                          height: 600
                        }) : null,
                      className: Core.cx("relative overflow-hidden bg-gray-100 aspect-[4/5]")
                    }),
                    className: Core.cx("block"),
                    href: HomeContent.artistLink(artist.username)
                  }),
                  JsxRuntime.jsxs("figcaption", {
                    children: [
                      JsxRuntime.jsx("span", {
                        children: HomeAtoms.pad(idx + 1 | 0),
                        className: Core.cx("text-[10px] tracking-widest text-gray-400 font-light tabular-nums")
                      }),
                      JsxRuntime.jsxs("span", {
                        children: [
                          artist.name,
                          country !== undefined ? JsxRuntime.jsx("span", {
                              children: HomeContent.flagEmoji(country),
                              "aria-label": country,
                              className: Core.cx("ml-2"),
                              title: country
                            }) : null
                        ],
                        className: Core.cx("text-xs text-gray-600 font-light tracking-wide")
                      })
                    ],
                    className: Core.cx("mt-3 flex items-baseline gap-3")
                  })
                ],
                className: Core.cx("group")
              }, artist.id);
            }),
            className: Core.cx("grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6")
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: t`Request an artist directly from their profile.`,
                className: Core.cx("text-sm md:text-base text-gray-600 font-light italic")
              }),
              JsxRuntime.jsx(HomeAtoms.ArrowLink.make, {
                href: HomeContent.allArtistsLink,
                label: t`Browse All Featured Artists`
              })
            ],
            className: Core.cx("mt-12 md:mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-gray-200 pt-8")
          })
        ],
        className: Core.cx("max-w-6xl mx-auto")
      }),
      className: Core.cx("w-full bg-[#faf9f6] px-6 md:px-12 pb-24 md:pb-32")
    });
  }
}

let make = FeaturedArtistsSection;

export {
  make,
}
/*  Not a pure module */
